"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleQrySelectionViewModel = instanceOfRoleQrySelectionViewModel;
exports.RoleQrySelectionViewModelFromJSON = RoleQrySelectionViewModelFromJSON;
exports.RoleQrySelectionViewModelFromJSONTyped = RoleQrySelectionViewModelFromJSONTyped;
exports.RoleQrySelectionViewModelToJSON = RoleQrySelectionViewModelToJSON;
exports.RoleQrySelectionViewModelToJSONTyped = RoleQrySelectionViewModelToJSONTyped;
/**
 * Check if a given object implements the RoleQrySelectionViewModel interface.
 */
function instanceOfRoleQrySelectionViewModel(value) {
    return true;
}
function RoleQrySelectionViewModelFromJSON(json) {
    return RoleQrySelectionViewModelFromJSONTyped(json, false);
}
function RoleQrySelectionViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'urUNo': json['urUNo'] == null ? undefined : json['urUNo'],
        'selectedUgNos': json['selectedUgNos'] == null ? undefined : json['selectedUgNos'],
    };
}
function RoleQrySelectionViewModelToJSON(json) {
    return RoleQrySelectionViewModelToJSONTyped(json, false);
}
function RoleQrySelectionViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'urUNo': value['urUNo'],
        'selectedUgNos': value['selectedUgNos'],
    };
}
